module.exports = __webpack_public_path__ + "static/media/buildingConstruction30.a6a8da0a.jpg";